import { render } from "./SearchViewPhone.vue?vue&type=template&id=03674542"
import script from "./SearchViewPhone.vue?vue&type=script&lang=js"
export * from "./SearchViewPhone.vue?vue&type=script&lang=js"

import "./SearchViewPhone.vue?vue&type=style&index=0&id=03674542&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__